(() => {
  const initProductHeroForms = (root = document) => {
    const sections = root.querySelectorAll('.mn-product-hero-pastel-v1');

    sections.forEach((section) => {
      if (section.dataset.heroAtcInit === '1') return;
      section.dataset.heroAtcInit = '1';

      const form = section.querySelector('.mn-product-hero-pastel-v1__form');
      if (!form) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const submitButton = form.querySelector('button[type="submit"]');
        if (submitButton && submitButton.disabled) return;

        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) {
          form.submit();
          return;
        }

        const originalLabel = submitButton ? submitButton.textContent : '';
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Adding...';
        }

        try {
          const formData = new FormData(form);
          formData.append(
            'sections',
            cartDrawer
              .getSectionsToRender()
              .map((sectionToRender) => sectionToRender.id)
              .join(',')
          );
          formData.append('sections_url', window.location.pathname);

          const addUrl = window.routes?.cart_add_url || '/cart/add';
          const response = await fetch(addUrl, {
            method: 'POST',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: formData,
          });

          const responseData = await response.json();
          if (responseData.status) {
            throw new Error(responseData.description || 'Add to cart failed');
          }

          cartDrawer.renderContents(responseData);
        } catch (error) {
          console.error(error);
        } finally {
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.textContent = originalLabel;
          }
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductHeroForms(document));
  } else {
    initProductHeroForms(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initProductHeroForms(event.target);
  });
})();
